import base from '../dr-base'
import drAutocompleteElem from './dr-autocomplete-elem.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-autocomplete-elem',
  name: 'Autocomplete element',
  group: 'Input widgets',
  icon: 'outdent',
  ...base,
  properties: {
    ...base.properties,
    Disabled: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.disabled',
      type: 'string',
      default: ''
    },
    Caption: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.caption',
      type: 'string'
    },
    Required: {
      name: 'vuetifyWidgets.general.required',
      type: 'boolean'
    },
    Value: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.value',
      type: 'string',
      hint: 'vuetifyWidgets.dr-autocomplete-elem.valueHint',
      component: 'dr-value-editor'
    },
    Style: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    Readonly: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.readonly',
      type: 'string'
    },
    Clearable: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.clearable',
      type: 'boolean'
    },
    Multiple: {
      name: 'vuetifyWidgets.dr-autocomplete-elem.multiple',
      type: 'boolean'
    },
    DataSource: {
      type: 'object',
      component: 'dr-autocomplete-data-source-editor',
      properties: {
        Type: {
          name: 'vuetifyWidgets.dr-autocomplete-elem.dataProvider',
          type: 'string',
          enum: [{
            value: 'datasource',
            text: 'DataSource'
          },
          {
            value: 'businessobject',
            text: 'BusinessObject'
          }]
        },
        Value: {
          name: 'vuetifyWidgets.dr-autocomplete-elem.dsValue',
          type: 'string'
        },
        DataSourceField: {
          name: 'vuetifyWidgets.dr-autocomplete-elem.dataSourceField',
          type: 'string'
        },
        Name: {
          name: 'vuetifyWidgets.dr-autocomplete-elem.name',
          type: 'string'
        },
        Code: {
          name: 'vuetifyWidgets.dr-autocomplete-elem.code',
          type: 'string'
        }
      }
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-autocomplete-elem.generationOnChange'
    }
  }
}


export default {
  schema,
  component: drAutocompleteElem,
  propEditors: [
    {
      name: 'dr-autocomplete-data-source-editor'
    },
    {
      name: 'dr-prop-action'
    }
  ]
}